/** CSS variable DevEnvironmentBanner sets to its height. */
export const DEV_BANNER_HEIGHT_VAR = "--dev-banner-height";

/** The height a full-window page fills: the window less the dev banner. Use instead of 100dvh. */
export const APP_HEIGHT = `calc(100dvh - var(${DEV_BANNER_HEIGHT_VAR}, 0px))`;
